import { render, staticRenderFns } from "./PlaceAdd.vue?vue&type=template&id=6ba463ba&"
import script from "./PlaceAdd.vue?vue&type=script&lang=js&"
export * from "./PlaceAdd.vue?vue&type=script&lang=js&"
import style0 from "./PlaceAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports